import { extractArgumentExternalRecordValue } from './extractArgumentExternalRecordValue.js';

export const buildArgumentExternalRecordArguments = (args = {}) => {
  const processedArgs = {};

  for (const [key, value] of Object.entries(args || {})) {
    processedArgs[key] = extractArgumentExternalRecordValue(value);
  }

  return processedArgs;
};
